import { render, staticRenderFns } from "./ProductFormVariantPrice.vue?vue&type=template&id=0b220701&"
import script from "./ProductFormVariantPrice.vue?vue&type=script&lang=js&"
export * from "./ProductFormVariantPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports